import { render, staticRenderFns } from "./WebResourceFileUpload.vue?vue&type=template&id=4c07a734&"
import script from "./WebResourceFileUpload.vue?vue&type=script&lang=js&"
export * from "./WebResourceFileUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Jenkins_Home\\workspace\\liveinfo3-front-admin-dev\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c07a734')) {
      api.createRecord('4c07a734', component.options)
    } else {
      api.reload('4c07a734', component.options)
    }
    module.hot.accept("./WebResourceFileUpload.vue?vue&type=template&id=4c07a734&", function () {
      api.rerender('4c07a734', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/deskinfo/web-resource-manage/WebResourceFileUpload.vue"
export default component.exports